import dayjs from "dayjs";
import { useMemo } from "react";

import { useSelectedFromStatuses } from "../../../hooks/useDrawRounds";

export const useScheduleDays = schedule => {
    const { podiums, breaks } = schedule;
    const days = useMemo(() => {
        const scheduleSize = Math.max(...podiums.map(podium => podium.heats.length));
        return [...Array(scheduleSize)].reduce((days, _, index) => {
            const heats = podiums.map(podium => podium.heats[index]);
            if (heats.filter(h => h).length) {
                const startOfDay = dayjs(heats.filter(h => h)[0].scheduledTime).startOf("day").format();
                days[startOfDay] = days[startOfDay] || podiums.map(_ => []);
                heats.forEach((heat, podiumIndex) => {
                    const day = days[startOfDay][podiumIndex];
                    if (day.length && day[day.length - 1] !== null && breaks.findIndex(b => b.position === index) > -1) day.push(null);
                    if (heat) day.push(heat);
                    else if (day.length && day[day.length - 1] !== null) day.push(null);
                });
            }
            return days;
        }, {});
    }, [podiums, breaks]);
    const sortedDays = useMemo(() => Object.keys(days).sort(), [days]);
    const daysStatuses = useMemo(() => {
        return sortedDays.map(day => {
            if (days[day].every(podiums => podiums.filter(h => h).every(heat => heat.endTime))) return "Complete";
            if (days[day].some(podiums => podiums.filter(h => h).some(heat => heat.startTime && !heat.endTime))) return "Live";
            if (days[day].some(podiums => podiums.filter(h => h).some(heat => heat.endTime))) return "Commenced";
            return "Upcoming";
        });
    }, [sortedDays]);

    const selectedDay = useSelectedFromStatuses(daysStatuses);

    return { days, sortedDays, selectedDay };
};
